import React from "react";
import { Building2, Users, UserPlus, ArrowRight } from "lucide-react";

const OrganizationEmptyState = () => {
  return (
    <div
      style={{
        scrollbarWidth: "none",
      }}
      className="flex flex-col w-[80%] items-center justify-center h-[90vh] overflow-y-scroll px-8 py-2 bg-gradient-to-br from-gray-50 to-gray-100"
    >
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="relative">
          <div className="w-20 h-20 mx-auto bg-gradient-to-br from-purple-100 to-purple-200 rounded-full flex items-center justify-center">
            <Building2 className="w-10 h-10 text-purple-600" />
          </div>
          <div className="absolute -top-1 -right-1 w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center">
            <Users className="w-4 h-4 text-yellow-600" />
          </div>
        </div>

        {/* Title */}
        <div className="space-y-2">
          <h2 className="text-2xl font-bold text-gray-900">
            No Organization Found
          </h2>
          <p className="text-gray-600 leading-relaxed">
            You're not currently associated with any organization. To access
            projects and collaborate with your team, you'll need to join an
            organization.
          </p>
        </div>

        {/* Action Cards */}
        <div className="space-y-4 pt-4">
          {/* Join Organization Card */}
          <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <UserPlus className="w-5 h-5 text-blue-600" />
              </div>
              <div className="flex-1 text-left">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Join an Organization
                </h3>
                <p className="text-sm text-gray-600 mb-3">
                  Ask your organization owner to add you to their organization
                  in SiteMaster.
                </p>
                {/* <div className="flex items-center text-sm text-blue-600 font-medium">
                  Contact your admin
                  <ArrowRight className="w-4 h-4 ml-1" />
                </div> */}
              </div>
            </div>
          </div>

          {/* Create Organization Card */}
          {/* <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <Building2 className="w-5 h-5 text-purple-600" />
              </div>
              <div className="flex-1 text-left">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Create an Organization
                </h3>
                <p className="text-sm text-gray-600 mb-3">
                  Want to start your own organization? Create an owner account
                  in SiteMaster to get started.
                </p>
                <div className="flex items-center text-sm text-purple-600 font-medium">
                  Create owner account
                  <ArrowRight className="w-4 h-4 ml-1" />
                </div>
              </div>
            </div>
          </div> */}
        </div>

        {/* Help Text */}
        <div className="pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Need help? Contact support or check our documentation for more
            information about organizations in SiteMaster.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrganizationEmptyState;
